// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__39AUd","cell":"ColumnAccessor_cell__1llVp","firstCellAccent":"ColumnAccessor_firstCellAccent__1WP_C"};